import { JoeHttps, Schema } from "../../../../../@types";
import { enums } from "../../../../../../../shim/jsbridge";
import Name from "../../../../../../search/schema/components/Name";

const { analyzer: { URLANALYZER = 1 } = {} } = enums || {};

export const https: Schema<JoeHttps> = {
  fields: [
    {
      name: "timestamp",
      displayTitle: "Timestamp",
      sortable: true,
      component: d => <>{d.timestamp}</>
    },
    {
      name: "srcip",
      displayTitle: "Source IP",
      sortable: true,
      component: d => (
        <Name
          data={{
            file_name: d.srcip,
            int_submission_analyzer: URLANALYZER
          }}
        />
      )
    },
    {
      name: "srcport",
      displayTitle: "Source port",
      sortable: true,
      component: d => <>{d.srcport}</>
    },
    {
      name: "dstip",
      displayTitle: "Destination IP",
      sortable: true,
      component: d => (
        <Name
          data={{
            file_name: d.dstip,
            int_submission_analyzer: URLANALYZER
          }}
        />
      )
    },
    {
      name: "dstport",
      displayTitle: "Destination port",
      sortable: true,
      component: d => <>{d.dstport}</>
    },
    {
      name: "out",
      displayTitle: "Direction",
      sortable: true,
      component: d => <>{d.out ? "OUT" : "IN"}</>
    },
    {
      name: "subject",
      displayTitle: "Subject",
      sortable: true,
      component: d => (
        <>{d.certificate !== null ? d.certificate?.subject : "--"}</>
      )
    },
    {
      name: "issuer",
      displayTitle: "Issuer",
      sortable: true,
      component: d => (
        <>{d.certificate !== null ? d.certificate?.issuer : "--"}</>
      )
    },
    {
      name: "not_before",
      displayTitle: "Not before",
      sortable: true,
      component: d => (
        <>{d.certificate !== null ? d.certificate?.notbefore : "--"}</>
      )
    },
    {
      name: "not_after",
      displayTitle: "Not after",
      sortable: true,
      component: d => (
        <>{d.certificate !== null ? d.certificate?.notafter : "--"}</>
      )
    }
  ]
};
